// extracted by mini-css-extract-plugin
export default {"avatar":"jjV8Qjksssfia_wjNEGb","xs":"wu91H8BIziEekzyHDlqp","sm":"JgZuBdjAr2vE2pFYf3k0","md":"jLSm_BM1r6zcseH5rOdm","lg":"qclCgleii8iYpLYEdRRd","image":"YvjquCtc2lJQTbYWgify"};